import React, { useEffect, useState } from 'react'
import { Filters } from '@ow/ditto'
import { pick } from 'lodash-es'
import { getQuery } from '@vt/utils'
import { useTbViewStore, useFetchRemoteData, useAppEx } from '@vt/hooks'

const Container = function () {
  const { fields, fixedFilters, setFilters, filters } = useTbViewStore(
    (state) =>
      pick(state, [
        'viewType',
        'fields',
        'fixedFilters',
        'setFilters',
        'filters',
        // 'defaultFilters',
      ])
  )
  const { tbs } = useAppEx()

  // 因为fixedFilters从接口请求回来，会有时间差异，所以加了个判断，等数据响应回来之后，再渲染筛选组件
  const [isRender, setRender] = useState(false)
  const { vid } = getQuery()
  useEffect(() => {
    setRender(false)
  }, [vid])
  useEffect(() => {
    setRender(true)
  }, [fixedFilters])

  const fetchRemoteData = useFetchRemoteData()
  if (!fixedFilters) {
    return null
  }
  return isRender ? (
    <Filters
      tbs={tbs}
      defaultValue={filters}
      fixedFilters={fixedFilters}
      fields={fields}
      onFetchRemoteData={fetchRemoteData}
      onChange={setFilters}
    />
  ) : null
}

export default Container
